import React from 'react';
import Draggable from 'react-draggable';
import { injectIntl } from 'react-intl';
class DraggableText extends React.Component {
    state = {
        width: 0,
        height: 0,
    };

    parseFontWeight = fontWeight => {
        const styles = { fontWeight: 'normal', fontStyle: 'normal' };
        if (fontWeight.includes('bold')) {
            styles.fontWeight = 'bold';
        }
        if (fontWeight.includes('italic')) {
            styles.fontStyle = 'italic';
        }
        return styles;
    };

    render() {
        const { id, color, size, font, rotation, textAlign, positionX, positionY } = this.props;
        const { messages } = this.props.intl;
        const { fontWeight, fontStyle } = this.parseFontWeight(this.props.fontWeight);
        const maxHeight = window.innerWidth < 1250 ? 10 : 20;
        const phase = Math.floor(rotation / 90);
        const ascending = phase % 2 === 0;
        const wrapperHeight = ascending ? (maxHeight * (rotation % 90)) / 100 + 3 : maxHeight - ((rotation % 90) * maxHeight - 4) / 100;
        const wrapperWidth = ascending ? maxHeight - ((rotation % 90) * maxHeight) / 100 : (maxHeight - 4 * (rotation % 90)) / 100 + 3;
        const positioning = positionX && positionY ? { left: `${positionX}%`, top: `${positionY}%` } : {};
        return (
            <Draggable bounds={'parent'}>
                <div
                    id={id}
                    className="react-avatar-picture-text-wrapper avatar-draggable-text"
                    style={{
                        height: `${wrapperHeight}em`,
                        width: `${wrapperWidth}em`,
                        ...positioning,
                    }}
                >
                    <div
                        style={{
                            transform: `rotate(${rotation}deg)`,
                        }}
                    >
                        <textarea
                            ref={textArea => (this.textArea = textArea)}
                            id="picture-text"
                            value={this.props.text || ''}
                            onChange={this.props.onChangeText}
                            className="react-avatar-picture-text"
                            style={{
                                color,
                                fontSize: size*maxHeight/20,
                                fontFamily: font,
                                fontWeight,
                                fontStyle,
                            }}
                        />
                    </div>
                </div>
            </Draggable>
        );
    }
}

export default injectIntl(DraggableText);



// WEBPACK FOOTER //
// ./src/Components/DraggableText.js